import React, { useState, useEffect } from 'react';
import { Button } from 'reactstrap';

//Components
import TabelaListagem from '../../../../components/TabelaListagem/TabelaListagem';
import CadastroTipoCompensacao from './Components/CadastroTipoCompensacao';

//Constants
import { actionsTable } from '../../../../constants/MaterialTable';

//Api
import tipoCompensacao_api from '../../../../api/tipoCompensacao_api';
import { showMessage } from '../../../../helpers/message';

//Context
import { useAuth } from '../../../../context/auth';

export default function TiposDeCompensacao({ permissoes }) {
    //variavel de edição dos campos
    const editavel = permissoes.filter(permissao => permissao.acao == "Editar").length > 0;

    //Pegando o estado de exibição do loading na tela
    const { setLoading } = useAuth();

    //Estado de controle da lista de tipos de compensação
    const [tiposCompensacao, setTiposCompensacao] = useState([]);

    //Estado que guarda o id do tipo de compensacao para edição
    const [idTipoCompensacao, setIdTipoCompensacao] = useState(null);

    //Estado de controle de exibição da tela de cadastro
    const [cadastro, setCadastro] = useState(false);

    //Função que salva o id do tipo de compensacao para edição
    const editar = (tipoCompensacao) => {
        setIdTipoCompensacao(tipoCompensacao.id);
    }

    //Ações que a tabela terá
    const actions = [actionsTable.editar(editar)];


    //Cabeçalhos que a tabela terá
    const headers = [
        { value: "Identificação", objectValue: "identificacao", align: "left" },
        { value: "Status", objectValue: "status", align: "left" }
    ]

    //Função que carrega os tipos de compensação
    const loadTiposDeCompensacao = () => {
        setLoading(true);
        tipoCompensacao_api.getList().then(response => {
            setTiposCompensacao(response.data);
        }).catch(e => showMessage("Erro", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Função que carrega a lista de tipos de compensação
    useEffect(() => {
        loadTiposDeCompensacao();
    }, []);

    if (cadastro || idTipoCompensacao)
        return <CadastroTipoCompensacao btnVoltar={() => {
            setCadastro(false);
            setIdTipoCompensacao(null);
            loadTiposDeCompensacao();
        }} id={idTipoCompensacao} editavel={editavel} />
    return (
        <>
            <div className='d-flex align-items-center justify-content-between mb-4'>
                <h4 className='text-secondary m-0'>Tipos de compensação</h4>
                {editavel &&
                    <Button color='success' onClick={() => { setCadastro(true) }}>+ Cadastrar</Button>
                }
            </div >
            <TabelaListagem actions={actions} title={"Lista de tipos de compensação"} options={{ print: false, search: true, pagination: true }} headers={headers} items={tiposCompensacao} />
        </>
    )
}